var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M1,4v15h22V4H1z M12,13.8l-3.9,2.3v-4.6V6.9L12,9.2l3.9,2.3L12,13.8z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }